//#region src/dom/youtube/props.ts
const youtubeMediaDefaultProps = {
	src: "",
	autoplay: false,
	defaultMuted: false,
	muted: false,
	loop: false,
	controls: false,
	playsInline: true,
	preload: "metadata",
	poster: "",
	source: null
};
//#endregion
export { youtubeMediaDefaultProps };

//# sourceMappingURL=props.js.map